export const ROUTE = {
  home: "/",
  about: "/about",
  sobre: "/sobre",
  project: "/projects",
  projetos: "/projetos",
  contact: "/contact",
  contato: "/contato",
  policy: "/policy",
  politica: "/politica-de-privacidade",
  projectDetails: "/projects/:slug",
};

export const EMAIL = {
  contact: "contato@basilis.co",
  subject: "Solicitação de Orçamento",
};

export const SOCIAL = {
  whatsapp:
    "https://wa.me/5519994386591?text=Ol%C3%A1%21%20Tudo%20bem%3F%20Tenho%20uma%20ideia%20e%20queria%20entender%20como%20voc%C3%AAs%20podem%20me%20ajudar.",
  instagram: "https://www.instagram.com/basilis.co",
};
